const ManageReports = 'ManageReports';

export const DELETE_REPORTS_REQUEST = `${ManageReports}/DELETE_REPORTS_REQUEST`;
export const DELETE_REPORTS_RESPONSE = `${ManageReports}/DELETE_REPORTS_RESPONSE`;
export const DELETE_REPORTS_ERROR = `${ManageReports}/DELETE_REPORTS_ERROR`;

export const OPEN_DELETE_REPORT_MODAL = `${ManageReports}/OPEN_DELETE_REPORT_MODAL`;
export const CLOSE_DELETE_REPORT_MODAL = `${ManageReports}/CLOSE_DELETE_REPORT_MODAL`;

export const OPEN_BULK_DELETE_REPORT_MODAL = `${ManageReports}/OPEN_BULK_DELETE_REPORT_MODAL`;
export const CLOSE_BULK_DELETE_REPORT_MODAL = `${ManageReports}/CLOSE_BULK_DELETE_REPORT_MODAL`;
